<div class="input-group md-3 auto-complete-input"  [formGroup]="formGroupModel">
  <label *ngIf="withLabel">{{placeholder}}:</label>
  <span class="autocomplete-loading-indicator" *ngIf="loading" aria-hidden="true"></span>
  <input #txtSearch apply-enter style="min-width: 158px;" [matAutocomplete]="auto" [placeholder]="placeholder" class="form-control"
    (cdkAutofill)="isAutofilled = $event.isAutofilled" (focus)="handleFocus()" (blur)="handleBlur()"
    (click)="handleClick()" [formControl]="stringValueControl" />
  <mat-autocomplete class="auto-complete-input-panel" [panelWidth]="txtSearch" [autoActiveFirstOption]="true" (optionSelected)="onOptionSelected($event)"
    #auto="matAutocomplete" #matAutocomplete>
    <mat-option class="autocomplete-state-option" disabled *ngIf="loading">
      טוען תוצאות...
    </mat-option>
    <mat-option class="autocomplete-state-option" disabled *ngIf="!loading && noResults && !canCreateCurrentValue">
      לא נמצאו תוצאות
    </mat-option>
    <mat-option [ngClass]="{'leftToRight': leftToRight, 'active': isActive(item)}" *ngFor="let item of searchResults" [value]="item">
      {{ item }}
    </mat-option>
    <mat-option class="autocomplete-create-option" *ngIf="!loading && canCreateCurrentValue" [value]="currentQuery">
      <span class="autocomplete-create-icon">+</span>
      <span>הוסף "{{ currentQuery }}"</span>
    </mat-option>
  </mat-autocomplete>
</div>
